export const metaSelector = (state) => state.meta.meta;
